import React from 'react';
import styled from 'styled-components';
import markSrc from './assets/kardume_logo_full.png';
import verticalSrc from './assets/logo_vertival.png';

const Img = styled.img<{ $radius?: string }>`
  display: block;
  width: auto;
  object-fit: contain;
  border-radius: ${(p) => p.$radius ?? '0'};
`;

interface LogoProps {
  /** Rendered pixel height of the official mark. */
  height?: number;
  /** Accepted for API compatibility; the official mark reads on any background. */
  onDark?: boolean;
  /** Rounds the image corners (e.g. 16 or "16px"). Used on the login screens. */
  radius?: number | string;
  /** Renders the vertical brand lockup (`logo_vertival.png`) instead of the full mark. Used on the login screens. */
  vertical?: boolean;
  className?: string;
}

/**
 * Kardume Urbano logo - renders the OFFICIAL brand asset image
 * (`assets/app_icon.png`, copied to `./assets/kardume_mark.png`) as-is.
 * The brand, logo, typography and palette must never be recreated or altered;
 * this component only sizes the official image (and optionally rounds corners).
 */
export const Logo: React.FC<LogoProps> = ({ height = 36, radius, vertical = false, className }) => {
  const r = typeof radius === 'number' ? `${radius}px` : radius;
  return (
    <Img
      src={vertical ? verticalSrc : markSrc}
      alt="Kardume Urbano"
      height={height}
      style={{ height }}
      $radius={r}
      className={className}
    />
  );
};

export default Logo;
